import { Button } from "../../Button";

import {
  Container,
  DecorationLeft,
  DecorationRight,
  Description,
  MainContent,
  Content,
  Image,
  Title,
} from "./styles";

export const Mobile = ({ image, title, description, buttonText }) => (
  <Container>
    <DecorationLeft />
    <Content>
      <Image src={image} alt="" />
      <MainContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Button>{buttonText}</Button>
      </MainContent>
    </Content>
    <DecorationRight />
  </Container>
);
